<template>
  <div :id="id" class="content" :style="`height: ${curHeight}`">
    <div class="content-box">
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img class="icon-title"
            src="../../../assets/images/icon_translate_interpreting_services.png"
          />
          <p class="p-style">{{resource["RESD807C259AEE674A"]}}</p>
          <p class="p-style">
            <span
              v-for="item in translateServiceInfo"
              :key="item.moduleCode"
              style="margin: 0 5px"
              @click="navDetailByContentCode('口译笔译', item)"
              @mouseenter="mouseOver(item, '923.6px')"
              >{{ item.moduleName }}</span
            >
          </p>
        </div>
        <div v-for="item in translateServiceInfo" :key="item.moduleCode">
          <div
            v-if="mouseModuleCode === item.moduleCode"
            class="hover-content hover-interpret"
          >
            <div
              v-html="moduleTranslateServiceMap[item.contentCode]"
              class="hover-box design-html"
              v-bind:style="{
                '--beforeLeft': 143 + 'px',
                '--afterLeft': 142 + 'px',
              }"
            ></div>
            <div class="more" @click="navDetailByContentCode('口译笔译', item)">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img class="icon-title"
            src="../../../assets/images/icon_translate_interpreting_equi_hire.png"
          />
          <p class="p-style">{{resource["RES347B95A11FACCAE"]}}</p>
          <p class="p-style">
            <span
              v-for="item in internationalConferenceInfo"
              :key="item.moduleCode"
              style="margin: 0 5px"
              @click="navDetailByContentCode('国际会议', item)"
              @mouseenter="mouseOver(item, '1054.6px')"
              >{{ item.moduleName }}</span
            >
          </p>
        </div>
        <div v-for="item in internationalConferenceInfo" :key="item.moduleCode">
          <div
            class="hover-content"
            v-if="mouseModuleCode === item.moduleCode"
            v-bind:style="{
              left: -395 + 'px',
              width: 1140 + 'px',
            }"
          >
            <div
              v-html="moduleInternationalConferenceMap[item.contentCode]"
              class="hover-box design-html"
              v-bind:style="{
                '--beforeLeft': 553 + 'px',
                '--afterLeft': 552 + 'px',
              }"
            ></div>
            <div class="more" @click="navDetailByContentCode('国际会议', item)">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img class="icon-title"
            src="../../../assets/images/icon_translate_teception_training.png"
          />
          <p class="p-style">{{resource["RES8FA256E641A0484"]}}</p>
          <p class="p-style">
            <span
              v-for="item in receptionTrainingInfo"
              :key="item.moduleCode"
              style="margin: 0 5px"
              @click="navDetailByContentCode('接待培训', item)"
              @mouseenter="mouseOver(item, '923.6px')"
              >{{ item.moduleName }}</span
            >
          </p>
        </div>
        <div v-for="item in receptionTrainingInfo" :key="item.moduleCode">
          <div
            class="hover-content"
            v-if="mouseModuleCode === item.moduleCode"
            v-bind:style="{
              left: -790 + 'px',
              width: 1140 + 'px',
            }"
          >
            <div
              v-html="moduleReceptionTrainingMap[item.contentCode]"
              class="hover-box design-html"
              v-bind:style="{
                '--beforeLeft': 993 + 'px',
                '--afterLeft': 992 + 'px',
              }"
            ></div>
            <div class="more" @click="navDetailByContentCode('接待培训', item)">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getInfoByGet,
  getModuleChild,
  getModuleInfo,
  getResource
} from "@/api/moduleContent";
import { pushContentAnnounceHtmlContent } from "../../../util/navUtils";

export default {
  name: "hover-box",
  props: {
    id: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      curHeight: "280px", // 260px
      mouseSelection: "",
      mouseModuleCode: "",
      mouseModuleItem: null,
      translateServiceInfo: [],
      moduleTranslateServiceMap: {},
      internationalConferenceInfo: [],
      moduleInternationalConferenceMap: {},
      receptionTrainingInfo: [],
      moduleReceptionTrainingMap: {},
      resource:{}
    };
  },
  created() {
    this.mouseModuleCode = this._.get(this, "$route.query.m", "");
    this.curHeight = this._.get(this, "$route.query.h", "280px");
    this.getResource()
    this.getTranslateService();
    this.getInternationalConferenceService();
    this.getReceptionTrainingInfoService();
  },
  methods: {
    getResource(){
      getResource("RES957BA9CF725D908").then(res=>{
        res.data.records&&res.data.records.forEach(e=>{
          // 翻译服务
          if(e.resourceCode === "RESD807C259AEE674A"){
            this.resource["RESD807C259AEE674A"] = e.resourceName
          }
          // 国际会议
          if(e.resourceCode === "RES347B95A11FACCAE"){
            this.resource["RES347B95A11FACCAE"] = e.resourceName
          }
          // 接待培训
          if(e.resourceCode === "RES8FA256E641A0484"){
            this.resource["RES8FA256E641A0484"] = e.resourceName
          }
        })
      })
    },
    //口译笔译
    getTranslateService() {
      getModuleInfo("RESD807C259AEE674A")
        .then((res) => {
          this.translateServiceInfo = [];
          let enterpriseChildArr = res.data.records.map((item) => {
            this.translateServiceInfo.push({ ...item });
            return getModuleChild(item.moduleCode, "contentNews");
          });
          return Promise.all(enterpriseChildArr);
        })
        .then((arr) => {
          const enterpriseChildInfoArr = arr.map((item) => {
            const { contentCode, moduleCode } = item.data.records[0];
            this.translateServiceInfo.forEach((val) => {
              if (val.moduleCode === moduleCode) {
                val["contentCode"] = contentCode;
              }
            });
            return getInfoByGet(contentCode, "contentNews");
          });
          return Promise.all(enterpriseChildInfoArr);
        })
        .then((datas) => {
          for (let index in datas) {
            const { contentHtml, contentCode, contentTitle } =
              datas[index].data;
            this.translateServiceInfo.forEach((val) => {
              if (val.contentCode === contentCode) {
                val["contentTitle"] = contentTitle;
              }
            });
            this.$set(this.moduleTranslateServiceMap, contentCode, contentHtml);
          }
        });
    },
    getInternationalConferenceService() {
      getModuleInfo("RES347B95A11FACCAE")
        .then((res) => {
          this.internationalConferenceInfo = [];
          let enterpriseChildArr = res.data.records.map((item) => {
            this.internationalConferenceInfo.push({ ...item });
            return getModuleChild(item.moduleCode, "contentNews");
          });
          return Promise.all(enterpriseChildArr);
        })
        .then((arr) => {
          const enterpriseChildInfoArr = arr.map((item) => {
            const { contentCode, moduleCode } = item.data.records[0];
            this.internationalConferenceInfo.forEach((val) => {
              if (val.moduleCode === moduleCode) {
                val["contentCode"] = contentCode;
              }
            });
            return getInfoByGet(contentCode, "contentNews");
          });
          return Promise.all(enterpriseChildInfoArr);
        })
        .then((datas) => {
          for (let index in datas) {
            const { contentHtml, contentCode, contentTitle } =
              datas[index].data;
            this.internationalConferenceInfo.forEach((val) => {
              if (val.contentCode === contentCode) {
                val["contentTitle"] = contentTitle;
              }
            });
            this.$set(
              this.moduleInternationalConferenceMap,
              contentCode,
              contentHtml
            );
          }
        });
    },
    getReceptionTrainingInfoService() {
      getModuleInfo("RES8FA256E641A0484")
        .then((res) => {
          this.receptionTrainingInfo = [];
          let enterpriseChildArr = res.data.records.map((item) => {
            this.receptionTrainingInfo.push({ ...item });
            return getModuleChild(item.moduleCode, "contentNews");
          });
          return Promise.all(enterpriseChildArr);
        })
        .then((arr) => {
          const enterpriseChildInfoArr = arr.map((item) => {
            const { contentCode, moduleCode } = item.data.records[0];
            this.receptionTrainingInfo.forEach((val) => {
              if (val.moduleCode === moduleCode) {
                val["contentCode"] = contentCode;
              }
            });
            return getInfoByGet(contentCode, "contentNews");
          });
          return Promise.all(enterpriseChildInfoArr);
        })
        .then((datas) => {
          for (let index in datas) {
            const { contentHtml, contentCode, contentTitle } =
              datas[index].data;
            this.receptionTrainingInfo.forEach((val) => {
              if (val.contentCode === contentCode) {
                val["contentTitle"] = contentTitle;
              }
            });
            this.$set(
              this.moduleReceptionTrainingMap,
              contentCode,
              contentHtml
            );
          }
        });
    },
    // 获取口译笔译
    // 移入
    mouseOver(moduleItem, height) {
      // if (
      //   moduleItem.moduleName == "文书笔译" ||
      //   moduleItem.moduleName == "口译服务"
      // ) {
      //   this.curHeight = "790px" || height;
      // } else {
        this.curHeight = "790px" || height;
      // }

      this.mouseModuleCode = moduleItem.moduleCode;
      this.mouseModuleItem = moduleItem;
    },
    // 移出
    mouseLeave() {
      this.curHeight = "280px";
      this.mouseModuleCode = "";
      this.mouseModuleItem = null;
    },
    navDetailByContentCode(parentName, moduleItem) {
      let contentType = "contentAnnounce";
      if (moduleItem.moduleClass === "news") {
        contentType = "contentNews";
      }
      let linkname = `翻译服务/${moduleItem.parentResourceName}/${moduleItem.moduleName}`;
      pushContentAnnounceHtmlContent(
        this,
        moduleItem.contentCode,
        moduleItem.moduleName,
        linkname,
        contentType
      );
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
  margin-top: 40px;

  &-box {
    width: 1140px;
    position: relative;
    margin: auto;
    // left: 50%;
    // transform: translateX(-50%);
    text-align: left;
    font-size: 0px;
  }
}

.box:not(:last-of-type) {
  margin-right: 45px;
}
.design-html img {
  width: 100%;
}
.box:hover {
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}

.box {
  width: 350px;
  height: 260px;
  display: inline-block;
  //border: 1px solid #DECBA4;
  //box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
  border: 1px solid #e5e5e5;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  cursor: default;
  position: relative;

  .box-item {
    position: relative;
    top: 22px;
    width: 350px;
    height: 260px;
  }

  .icon-title {
    width: 64px;
    height: 64px;
    margin-top: 39px;
  }

  .p-style {
    margin: 0;
    padding: 0;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-top: 23px;
  }

  .p-style:last-of-type {
    margin-top: 18px;

    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      cursor: pointer;
    }

    span:hover {
      color: #cbb486;
    }
  }

  .hover-title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-top: 20px;
  }

  .hover-title:not(first-of-type) {
    margin-top: 10px;
  }

  .hover-desc {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3a3a3a;
  }
}

/deep/.hover-content {
  width: 1140px;
  height: 510px;
  overflow: hidden;
  position: absolute;
  top: 281px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  padding: 48px;
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
  // z-index: 99999;
}

/deep/.hover-interpret {
  height: 510px;
}

.hover-box {
  flex: 1;
  text-align: left;

  p {
    padding: 0;
    margin: 0;
    padding-bottom: 15px;
  }

  div:hover {
    color: #cbb486;
  }

  div:hover .down-btn {
    display: inline-block;
  }

  .boxx {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 68px;
    border-bottom: 1px solid #eee;
    padding-left: 15px;
    position: relative;
    white-space: nowrap;

    .down-btn {
      line-height: 36px;
      color: #cbb486;
    }

    // img {
    //   line-height: 36px;
    //   margin-top: 0px;
    // }
  }

  .boxx::before {
    content: "";
    display: inline-block;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    background: rgba(203, 180, 134, 1);
    position: absolute;
    left: -1px;
    top: 31px;
  }
}

// .hover-box:first-of-type {
//   margin-right: 40px;
// }

.down-btn {
  display: inline-block;
  display: none;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #cbb486;
  vertical-align: middle;
  text-align: center;

  img {
    width: 16px;
    height: 16px;
  }
}

.more {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #cab484;
  position: absolute;
  display: block;
  height: 70px;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  background: white;
  width: 100%;
  line-height: 70px;
  text-align: center;
}

.hover-box::before {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -16px;
  //left:143px;
  left: var(--beforeLeft);
  padding: 0;
  border-bottom: 8px solid #ffffff;
  border-top: 8px solid transparent;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  display: block;
  content: "";
  z-index: 12;
}

.hover-box::after {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -18px;
  //left:142px;
  left: var(--afterLeft);
  padding: 0;
  border-bottom: 9px solid #cbb486;
  border-top: 9px solid transparent;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  display: block;
  content: "";
  z-index: 10;
}

//.p{
//  span{
//    color: #7F7F7F;
//  }
//  span:hover{
//    color: #CBB486;
//  }
//}
</style>



// WEBPACK FOOTER //
// src/components/home/translationService/siderContent-01.vue